import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export interface CollapseChevronProps {
  collapsed: boolean;
  fontSize?: number;
}

/**
 * The expand/collapse indicator shared by collapsible section headers.
 *
 * Points right when closed and rotates down when open, the same way the left
 * nav's chevron behaves (LeftNavV2/NavItemV2).
 */
export function CollapseChevron({ collapsed, fontSize = 18 }: CollapseChevronProps) {
  return (
    <ChevronRightIcon
      sx={{
        fontSize,
        transform: collapsed ? "rotate(0deg)" : "rotate(90deg)",
        transition: "transform 0.2s ease-in-out",
      }}
    />
  );
}
